import React, { ReactNode } from 'react';
import DialogMui from '@mui/material/Dialog';
import DialogTitleMui from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useMobile from 'common/hooks/useMobile';

type DialogTitleProps = {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
};

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitleMui {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: (theme) => theme.palette.primary.main,
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitleMui>
  );
};

type Props = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  content: ReactNode;
  actions?: ReactNode;
};

export const Dialog = ({ open, onClose, title, content, actions }: Props) => {
  const isMobile = useMobile();
  return (
    <div>
      <DialogMui
        onClose={onClose}
        aria-labelledby="dialog-title"
        open={open}
        fullWidth
        maxWidth="viewportS"
      >
        <DialogTitle id="dialog-title" onClose={onClose}>
          {title}
        </DialogTitle>
        <DialogContent dividers sx={{ borderBottom: 'none' }}>
          {content}
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: isMobile ? 'center' : undefined,
          }}
        >
          {actions}
        </DialogActions>
      </DialogMui>
    </div>
  );
};
